var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "86px",
    height: "106px",
    viewBox: "0 0 86 106",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-apple") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-apple",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.8245757,56.3144672 C71.9729986,72.3558068 85.8462965,77.693898 86,77.7618473 C85.882695,78.1381238 83.7832747,85.3689537 78.6908794,92.8378901 C74.2885468,99.295347 69.7198749,105.728766 62.5225901,105.862015 C55.4505312,105.992803 53.1764736,101.653321 45.0911031,101.653321 C37.0081843,101.653321 34.4816003,105.728955 27.7871051,105.992992 C20.839895,106.257029 15.5494767,99.0104898 11.1109341,92.5766922 C2.04091819,79.4164795 -4.89045012,55.3891073 4.41662757,39.1702288 C9.04018008,31.1158682 17.3028283,26.0155051 26.2711924,25.8847168 C33.0931767,25.7541178 39.532128,30.4908859 43.7026794,30.4908859 C47.8705906,30.4908859 55.6953252,24.7944993 63.9213863,25.6310898 C67.3650994,25.774938 77.0318244,27.0271739 83.238806,36.1456322 C82.7386566,36.4567985 71.7046304,42.9034667 71.8245757,56.3144672 M58.5334653,16.9244915 C62.2217838,12.443811 64.704237,6.20629042 64.0269986,0 C58.7105544,0.214447302 52.2817871,3.55550977 48.4684313,8.03372969 C45.0509327,11.999396 42.0579576,18.3466954 42.8655139,24.4301471 C48.791303,24.8902719 54.8449582,21.4080111 58.5334653,16.9244915",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApple);
export default __webpack_public_path__ + "static/media/logo-apple.2c9fa987f354f5eb0f32fc5a7ef68cce.svg";
export { ForwardRef as ReactComponent };